import cloneDeep from 'lodash.clonedeep'

export function setFormValues(state, value) {
  state.formValues = cloneDeep(value)
}

export function setFilterValues(state, payload) {
  const formValues = state.formValues
  let targetValues = formValues[payload.target]
  if (targetValues.includes(payload.value)) {
    targetValues = targetValues.filter((e) => e != payload.value)
  } else {
    targetValues.push(payload.value)
  }
  formValues[payload.target] = targetValues
  state.formValues = formValues
}

export function toggleFilterValues(state, payload) {
  const formValues = state.formValues
  let targetValues = formValues[payload.target]
  if (payload.allChecked) {
    targetValues = payload.initialValues
  } else {
    targetValues = []
  }
  formValues[payload.target] = targetValues
  state.formValues = formValues
}
